import { injectable, inject } from 'inversify';
import type { EcosystemUsageReportDTO, IReportRepository } from '@/domain/repositories/IReportRepository';
import { TYPES } from '@/di/tokens';

@injectable()
export class GetEcosystemUsageAction {
  constructor(
    @inject(TYPES.IReportRepository) private reportRepository: IReportRepository
  ) {}

  async execute(period?: string): Promise<EcosystemUsageReportDTO> {
    return this.reportRepository.getEcosystemUsage(period);
  }
}
